// Fun Facts, Rätsel und lustige Sprüche für RestroomAdvisor
// Wird auf der Welcome-Seite angezeigt und wechselt bei jedem Seitenladen

const funFactsDE = [
  // Historische Fun Facts
  "Der 19. November ist der Welttoilettentag.",
  "Der Begriff Toilette stammt von französischen Waschtischen.",
  "Gut ausgebaute Abortanlagen gab es bereits um 2800 v. Chr. in Mesopotamien",
  "In Rom ging man gegen Gebühr auf öffentliche Latrinen. Pecunia non olet.",
  "Sir John Harington erfand 1596 das erste Wasserklosett der Neuzeit.",
  "George Jennings stellte das moderne WC 1851 in London erstmals aus.",
  "Elvis Presley starb auf einer Toilette.",
  
  // Kurioses & Wissenswertes
  "In Eisenbahnen sind Unisex-Toiletten üblich.",
  "Nette Toiletten sind von Händlern kostenlos öffentlich nutzbare WCs.",
  "In japanischen Toiletten übertönt oft ein Lautsprecher die Körpergeräusche.",
  "Paruresis ist die Angst vor dem Urinieren in öffentlichen Toiletten.",
  "In Amerika landeten bereits über 7 Millionen Handys in Abflussrohren.",
  "Die teuerste Toilette der Welt ist aus massivem Gold und steht in Hongkong.",
  "Wir verbringen durchschnittlich 3 Jahre unseres Lebens auf der Toilette.",
  "In Japan gibt es Toiletten mit beheizten Sitzen und eingebauten Bidets.",
  "Es gibt mehr Menschen auf der Welt mit einem Handy als mit einer funktionierenden Toilette.",
  "In Finnland gibt es eine Toilettenweltmeisterschaft, bei der Teilnehmende auf mobilen Klos Rennen fahren.",
  "Der Euro-Schlüssel öffnet eine Vielzahl von behindertengerechten Toiletten in Europa.",  
  
  // Film & Kultur
  "\"Psycho\" zeigte 1960 erstmals eine spülende Toilette - und erntete Beschwerden.",
  "In Südkorea gibt es ein Toiletten-Museum in einem toilettenförmigen Gebäude.",
  
  // Klopapier-Facts
  "Die Chinesen nutzten im 14. Jahrhundert erstmals Klopapier - aus Bambus.",
  "Jeder Deutsche verbraucht etwa 20 Blatt Klopapier pro Tag - einen Kilometer im Jahr.",
  "70% der Deutschen falten ihr Klopapier, 7% knüllen es, 2% wickeln es um die Hand.",
  
  // Weisheiten 
  "Jeder Thron hat seine Geschichte.",
  "Wo ein Wille ist, ist auch ein WC.",
  "Das Leben ist zu kurz für schlechte Toiletten.",
  "Die besten Ideen kommen einem auf Klo! 💡",
  "Was für eine Shitshow!",
  "Nicht vergessen: Runter ist Pflicht, hoch ist Kür.",
  "Das Klo ist wie das Leben - manchmal läufts, manchmal nicht.",
  "Bitte sauber hinterlassen - auch der nächste hat eine Nase.",
  "Klopapier ist wie ein Freund - man merkt erst, wie wichtig es ist, wenn es fehlt.",
  
  //Community
  "Danke, dass du Teil der Restroom Advisor Community bist! ❤️",
  "Sei der Held, den deine Stadt braucht: Bewerte Toiletten!",
  "Gemeinsam machen wir öffentliche Toiletten besser!",
  "Kein Mensch pisst illegal... dank der App!",
];
const funFactsEN = [
  // Historical Fun Facts
  "November 19th is World Toilet Day.",
  "The word 'toilet' derives from the French 'toilette', meaning a cloth for grooming.",
  "Well-developed toilet facilities existed as early as 2800 BC in Mesopotamia.",
  "In Rome, people used public latrines for a fee. Pecunia non olet.",
  "Sir John Harington invented the first flush toilet of modern times in 1596.",
  "George Jennings exhibited the modern WC for the first time in London in 1851.",
  "Elvis Presley died on a toilet.",
  
  // Curious & Worth Knowing
  "Unisex toilets are common on trains.",
  "Some businesses in Germany provide free public restrooms as a community service.",
  "In Japanese toilets, a speaker often drowns out body sounds.",
  "Paruresis is the fear of urinating in public toilets.",
  "In America, over 7 million phones have already ended up in drainpipes.",
  "The world's most expensive toilet is made of solid gold and is located in Hong Kong.",
  "We spend an average of 3 years of our lives on the toilet.",
  "In Japan, there are toilets with heated seats and built-in bidets.",
  "There are more people in the world with a phone than with a functioning toilet.",
  "In Finland, there's a toilet world championship where participants race on portable loos.",
  "The Euro key opens accessible toilets across Europe for people with disabilities.",
  
  // Film & Culture
  "\"Psycho\" showed a flushing toilet for the first time in 1960 - and received complaints.",
  "In South Korea, there's a toilet museum in a toilet-shaped building.",
  
  // Toilet Paper Facts
  "The Chinese first used toilet paper in the 14th century - made from bamboo.",
  "The average person uses about 20 sheets of toilet paper per day - one kilometer per year.",
  "70% of people fold their toilet paper, 7% crumple it, 2% wrap it around their hand.",
  
  // Wisdom
  //"Every throne has its story.",
  //"Where there's a will, there's a WC.",
  "Life is too short for bad toilets.",
  "The best ideas come to you on the toilet! 💡",
  "What a shitshow!",
  //"Don't forget: Down is mandatory, up is optional.",
  "The toilet is like life - sometimes it flows, sometimes it doesn't.",
  "Please leave it clean - the next person has a nose too.",
  "Toilet paper is like a friend - you only realize how important it is when it's missing.",
  
  // Community
  "Thank you for being part of the Restroom Advisor community! ❤️",
  "Be the hero your city needs: Rate restrooms!",
  "Together we make public toilets better!",
  "No one pees illegally... thanks to the app!",
];

// Funktion zum Abrufen eines zufälligen Fun Facts
export const getRandomFunFact = (language = 'de') => {
  const facts = language === 'en' ? funFactsEN : funFactsDE;
  const randomIndex = Math.floor(Math.random() * facts.length);
  return facts[randomIndex];
};

// Optional: Funktion zum Abrufen mehrerer unterschiedlicher Fun Facts
export const getRandomFunFacts = (count = 3, language = 'de') => {
  const facts = language === 'en' ? funFactsEN : funFactsDE;
  const shuffled = [...facts].sort(() => 0.5 - Math.random());
  return shuffled.slice(0, count);
};

export default funFactsDE;